import { useState } from 'react';
import { useIsoLayoutEffect } from './useIsoLayoutEffect';

// Reports whether the page is live in the browser: false for the first drawing — the one a server also makes, which the
// browser must match to take it over — and true from the next one, before anything is painted.
export function useHasMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useIsoLayoutEffect(() => setMounted(true), []);
  return mounted;
}
